import { Fragment, useEffect, useState } from "react";
import cartimg from "../../assets/logo/icons8-cart-96.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TopHeader from "./TopHeader";
import MenuHeader, { MobileHeader } from "./MenuHeader";
import SideNav from "./SideNav";
import ShopingCart from "./ShopingCart";
import { getcategory } from "../../store/products/productAction";
import Search from "./Search";
import { getLogo } from "../../store/cart/cartAction";
import { baseUrl } from "../../utils/APi";
import CenterHead from "./CenterHead";
import logo from "../../assets/icon.png";

const Header = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { category } = useSelector((state) => state.Productslice);
  const lan = useSelector((state) => state.LanSlicer.language);
  // const { cart, favlist, logo } = useSelector((state) => state.cartSlice);
 
  // useEffect(() => {
  //   dispatch(getcategory(lan));
  //   if (!logo) {
  //     const promise = dispatch(getLogo());
  //     return () => {
  //       promise.abort();
  //     };
  //   }
  // }, [lan, dispatch]);

  return (

    <header className="nav-type-1">
        
        <TopHeader />
         <CenterHead />
        {/* <MenuHeader /> */} 
      </header>
  
  );
};
export default Header;
